import { resolveSettingsSections } from '@/features/campaign-whatsapp-ai-config/settings-sections'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/company/$companyId/$campaignId/settings/')({
	component: RouteComponent,
})

// Redirect the bare settings path to the first enabled section (priority set by
// resolveSettingsSections); show the empty state when none are enabled.
function RouteComponent() {
	const { companyId, campaignId } = Route.useParams()
	const { t } = useTranslation('common')
	const sections = resolveSettingsSections({
		interview: true,
		whatsappAi: useBooleanFlagValue('whatsapp-ai-agent', false),
	})

	const first = sections[0]
	if (first) {
		return <Navigate to={first.to} params={{ companyId, campaignId }} replace={true} />
	}

	return (
		<div className="flex min-h-64 items-center justify-center py-8 text-sm text-grey-400">
			{t('campaign.settings.empty')}
		</div>
	)
}
